

const TIMEOUT = {
    slider: 500
}

module.exports = { TIMEOUT }